import LeftBar from "./components/LeftBar";
import RightBar from "./components/RightBar";
import "./App.css";

function App() {
  return (
    <div className="App">
      <LeftBar/>
      <RightBar/>
    </div>
  );
}

export default App;
